<div class="token-placement-modal">
  <div class="token-placement-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
      <circle cx="12" cy="12" r="9.2" stroke="currentColor" stroke-width="1.6" />
      <path d="M12 11v5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="7.6" r="1" fill="currentColor" />
    </svg>
  </div>

  <h4 class="token-placement-title">Token Placement</h4>

  <div class="token-placement-body">
    <p>When entering a city, all player and game tokens must begin their movement at the outskirts of the settlement (blue).</p>
    <p>When leaving a city, tokens must first be moved to the outskirts before continuing onward.</p>
    <p class="token-placement-note">Please place your token at the city outskirts to begin.</p>
  </div>

  <div class="token-placement-actions">
    <button type="button" class="btn btn-theme" (click)="close()">Got it</button>
  </div>
</div>
